import React from "react";
import { Step9ScheduleReserveContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import queryString from "query-string";
import moment from "moment";
import { toast } from "react-toastify";
import { userService } from "apiServices";
import {
  IS_BOOKING_DATE_ERROR,
  RENDER_API_ERROR_MESSAGE,
} from "utils/functions/roomBooking";
import { withTranslation } from "react-i18next";
import { BtnRoomBookingSentWidget, HeaderBackMusicHallWidget } from "widgets";
import { Displays, Forms, Headers, Navigations } from "components";

class Step9ScheduleReserveContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { router } = this.props;
    this.setState({
      initialValues: {
        ...queryString.parse(router.location.search),
      },
      isLoading: false,
    });
  };

  handleBack = () => {
    const { router } = this.props;
    const { id } = this.props.router.params;
    this.props.router.navigate(
      `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/8${router.location.search}`,
    );
  };

  handleSubmit = async (values) => {
    const { initialValues } = this.state;
    const { router, t } = this.props;
    const { id } = this.props.router.params;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...queryString.parse(router.location.search),
      ...values,
      booking_date: moment(
        queryString.parse(router.location.search).booking_date,
      ).format("YYYY-MM-DD"),
      room_ref_id: id,
      equipment_list: [],
      type: "1",
    };
    if (values.additional_equipment_additional) {
      params.equipment_list = values.additional_equipment_additional
        .split(",")
        .filter((e) => e);
    }
    if (values.additional_equipment_provider) {
      params.equipment_list = [
        ...params.equipment_list,
        ...values.additional_equipment_provider.split(",").filter((e) => e),
      ];
    }
    // query string เก็บวันสำรองเป็น JSON (แต่ละวันมีเวลาของตัวเอง) แปลงกลับก่อนส่งให้ API
    try {
      params.alternative_booking_dates = JSON.parse(
        queryString.parse(router.location.search).alternative_booking_dates ||
          "[]",
      );
    } catch (error) {
      params.alternative_booking_dates = [];
    }
    let res = await userService.POST_ROOM_BOOKING_DRAFT(params);
    if (res && res.status === 200) {
      this.setState({
        isBgLoading: false,
      });
      toast.success(t("Save draft successfully", { ns: "common" }));
      const queryStringTemp = new URLSearchParams({
        ...initialValues,
        ...values,
        room_booking_id: res.data._id,
        is_preview: true,
      }).toString();
      this.props.router.navigate(
        `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/3?${queryStringTemp}`,
      );
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error(
        RENDER_API_ERROR_MESSAGE(
          res,
          t("Something went wrong. Please try again.", { ns: "common" }),
        ),
      );
      // ถ้าพลาดเพราะวัน/เวลา พากลับไปหน้าเลือกวันให้เลย ลูกค้าจะได้ไม่ต้องไล่กด Back เอง
      if (IS_BOOKING_DATE_ERROR(res)) {
        this.props.router.navigate(
          `${ROUTE_PATH.MUSIC_HALL}/${id}/booking/4${router.location.search}`,
        );
      }
    }
  };

  render() {
    const { router, t } = this.props;
    const isPreview =
      queryString.parse(router.location.search)?.is_preview === "true";
    const { isBgLoading, isLoading, initialValues } = this.state;
    const DATE_BREADCRUMB = [
      {
        name: t("Home", { ns: "common" }),
        path: ROUTE_PATH.HOME,
      },
      {
        name: t("Music Hall Bangkok", { ns: "common" }),
        path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
      },
    ];
    return (
      <Step9ScheduleReserveContainerStyled isPreview={isPreview}>
        <Displays.BGLoading visible={isBgLoading} />
        <div className="breadcrumb_layout">
          <Navigations.Breadcrumb data={DATE_BREADCRUMB} />
        </div>
        <div className="step_schedule_reserve_container">
          {!isPreview ? (
            <div className="header_layout">
              <Headers.NewPageHeader
                title={"YAMAHA MUSIC  HALL, BANGKOK"}
                sub_title={"Rental Registration form "}
              />
            </div>
          ) : (
            <div className="header_backhome_layout">
              <HeaderBackMusicHallWidget room_booking_id={router.params.id} />
            </div>
          )}
          {isPreview && (
            <div className="title_preview">
              {t("Review Information", { ns: "common" })}
            </div>
          )}
          <div className="detail_layout">
            <Displays.TitleReserve
              title_reserve={`7. ${t(
                "Terms and Conditions Agreement from Renter",
                { ns: "room" },
              )}`}
            />
          </div>
          {isLoading ? (
            <Displays.Loading />
          ) : (
            <Forms.MusicHallRegisTermConditionForm
              isDisabledForm={isPreview}
              initialValues={initialValues}
              onBack={this.handleBack}
              onSubmit={this.handleSubmit}
            />
          )}
          {isPreview && (
            <div className="btn_confirm_wrap">
              <BtnRoomBookingSentWidget
                room_booking_id={
                  queryString.parse(router.location.search)?.room_booking_id
                }
              />
            </div>
          )}
        </div>
      </Step9ScheduleReserveContainerStyled>
    );
  }
}

export default withTranslation(["common", "room"])(
  withRouter(Step9ScheduleReserveContainer),
);
